import { Sparkles, Award } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import alexaiLogo from "@/assets/alexai-pro-avatar.png";

const AI = () => {
  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-6 py-10 max-w-4xl">
        <div className="mb-10 animate-fade-in">
          <div className="flex items-center gap-4 mb-3">
            <img src={alexaiLogo} alt="AlexAI Pro" className="w-12 h-12 rounded-md flex-shrink-0 ring-1 ring-border/50" />
            <h1 className="text-2xl sm:text-4xl font-semibold text-foreground tracking-tight">
              AlexAI<span className="text-primary">Pro</span>
            </h1>
          </div>
          <p className="text-muted-foreground text-sm sm:text-lg tracking-wide">The world's most powerful energy AI</p>
        </div>

        <Card className="mb-10 border-border/60 bg-gradient-to-br from-secondary/50 to-muted/30 animate-fade-in-up">
          <CardContent className="pt-6 pb-6">
            <div className="flex flex-col gap-4">
              <h2 className="text-2xl font-semibold text-foreground tracking-refined">Welcome to AlexAI Pro</h2>
              <p className="text-muted-foreground leading-relaxed">
                AlexAI Pro is the world's most powerful energy AI. It combines GPT-5's reasoning with Alex Epstein's method of thinking to help you generate tailored talking points, op-eds, policy proposals, lobbying plans, and news analysis from an energy freedom perspective.
              </p>
              <div>
                <Button size="lg" className="w-full sm:w-auto group" asChild>
                  <a href="https://pro.alexepstein.ai" target="_blank" rel="noopener">
                    <Sparkles className="w-4 h-4 mr-2" />
                    Launch AlexAI Pro
                  </a>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        <div>
          <Card className="border-border/60 bg-gradient-to-br from-secondary/50 to-muted/30">
            <CardHeader>
              <div className="flex items-center gap-2">
                <Award className="w-5 h-5 text-gold" />
                <CardTitle className="text-base font-medium">Licenses by Membership Tier</CardTitle>
              </div>
              <CardDescription>Team access varies by tier</CardDescription>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-center justify-between py-2">
                <span className="text-sm font-medium">Insider (25K)</span>
                <Badge variant="outline">1 License</Badge>
              </div>
              <Separator />
              <div className="flex items-center justify-between py-2">
                <span className="text-sm font-medium">Influencer (50K)</span>
                <Badge variant="outline">3 Licenses</Badge>
              </div>
              <Separator />
              <div className="flex items-center justify-between py-2">
                <span className="text-sm font-medium">Champion (100K)</span>
                <Badge variant="outline">10 Licenses</Badge>
              </div>
              <Separator />
              <div className="flex items-center justify-between py-2">
                <span className="text-sm font-medium">Partner (250K)</span>
                <Badge variant="outline">20 Licenses</Badge>
              </div>
              <div className="pt-3 border-t">
                <p className="text-xs text-muted-foreground">
                  To add team members, email <a href="mailto:michelle@alexepstein.com" className="text-primary hover:underline">michelle@alexepstein.com</a> with their names and email addresses.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AI;
